import { inject } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { InMemoryCacheService } from '../common';
import { UtilsService } from '../common';

export enum PlanFeature {
  SEO = 'seoPlan',
  KEVIN_AI = 'askKevinPlan',
  BUSINESS_CARD = 'businessCardPlan'
}

export const planGuard = (requiredPlan: PlanFeature) => {
  return async (): Promise<boolean | UrlTree> => {
    const cache = inject(InMemoryCacheService);
    const router = inject(Router);
    const utils = inject(UtilsService);

    // Fetch claims
    const getClaims = await cache.getClaims();

    // Filter only Plan type
    const currentPlans = getClaims?.data?.filter(c => c?.type === 'Plan');

    utils.logger.info("Current Plans: ", currentPlans); // log all plans

    // Check if user has the required plan
    const hasPlan = currentPlans?.some(p => p?.value === requiredPlan); // true if any plan matches

    // For SEO plan, also check reviews and brand monitoring
    // if (requiredPlan === PlanFeature.SEO) {
    //   const hasSeoPlan = cache.claims?.some(claim =>
    //     claim.type === 'Plan' &&
    //     (claim.value === 'seoPlan' ||
    //      claim.value === 'reviewsPlan' ||
    //      claim.value === 'brandMonitoringPlan')
    //   );
    //   if (hasSeoPlan) return true;
    // }

    if (!hasPlan) {
        utils.logger.info("Access Denied: ", requiredPlan);
        // Redirect to manage-redirect page
        return router.createUrlTree(['/manage-redirect']);
    }

    return true;
  };
};
